export function today() { return new Date().toISOString().slice(0, 10); }
export function fmt(v, digits = 0) { return Number(v || 0).toLocaleString("tr-TR", { maximumFractionDigits: digits }); }
let _ridc = 0;
export const rid = () => `ri${Date.now().toString(36)}${(_ridc++).toString(36)}`;
export const EMPTY_RATION = { name: "", animal_count: 0, feeding_animal_count: "", feeding_groups: [], meals_per_day: 2, meal_times: [], notes: "", items: [] };
export const EMPTY_CAT = { name: "", category: "konsantre", protein_pct: 0, energy_mcal: 0, notes: "" };
